<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-select ttLabel="category_keyno_top" [(ttModel)]="setting.category_keyno_top" (ttModelChange)="onChanged($event, 'category_keyno_top')" [ttData]="selectListMainCategories" ttDataId="item_id" ttDataName="item_name"></tt-select>

            <tt-tabs [(ttSelectedId)]="selectedBgCategoryDataSelection">
                <tt-tab ttId="A" ttLabel="categorydatas_all"></tt-tab>
                <tt-tab ttId="S" ttLabel="categorydatas_selected"></tt-tab>
            </tt-tabs>

            <div *ngFor="let item of inputListCategoryDatas">
                <label [hidden]="selectedBgCategoryDataSelection !== 'A' && item.rectype !== 'H' && item.visible !== '1'" class="checklist-h1 col-xs-12">{{item.category_name}}</label>
                <tt-checkbox [hidden]="(selectedBgCategoryDataSelection !== 'A' && item.rectype !== 'D' && item.visible !== '1') || (selectedBgCategoryDataSelection !== 'S' && item.selected !== '1')" ttLabel="{{item.category_name}}" [(ttModel)]="item.selected"></tt-checkbox>
            </div>

            <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        </tt-card>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="categorydatas_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="40">
                    <tt-card class="col-xs-12 p-5">
                        <tt-select ttLabel="category_keyno_top" [(ttModel)]="setting.category_keyno_top" (ttModelChange)="onChanged($event, 'category_keyno_top')" [ttData]="selectListMainCategories" ttDataId="item_id" ttDataName="item_name"></tt-select>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="30">
                    <tt-card class="col-xs-12 p-5" ttHeading="categorydatas_all">
                        <div *ngFor="let item of inputListCategoryDatas">
                            <label [hidden]="item.rectype !== 'H' && item.visible !== '1'" class="checklist-h1 col-xs-12">{{item.category_name}}</label>
                            <tt-checkbox [hidden]="item.rectype !== 'D' && item.visible !== '1'" ttLabel="{{item.category_name}}" [(ttModel)]="item.selected"></tt-checkbox>
                        </div>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="30">
                    <tt-card class="col-xs-12 p-5" ttHeading="categorydatas_selected">
                        <tt-checkbox [hidden]="item.selected !== '1'" *ngFor="let item of inputListCategoryDatas" ttLabel="{{item.category_name}}" [(ttModel)]="item.selected"></tt-checkbox>
                    </tt-card>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>

        <tt-card class="col-xs-12 p-5">
            <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        </tt-card>
    </div>
</tt-page>
